import { configureTemplateAssets } from "@smartworkstechnology/storefront-renderer/storefront";

/**
 * Where templates' default photography lives: this environment's Super Admin
 * media root (dashboard → Admin → Media; each template is a folder under it).
 * Velora names its default photographs instead of hotlinking them, and the
 * renderer resolves those names against this base — in the editor canvas, the
 * preview and the gallery alike.
 *
 * Imported for its side effect from the app entry, before anything renders.
 */
// Every environment serves templates' default photography from the same Super
// Admin media root, so it is the default; the env var only overrides it.
const DEFAULT_TEMPLATE_ASSET_BASE =
  "https://storemandudevstorage.blob.core.windows.net/dev-product-media/SuperAdmin";

configureTemplateAssets({
  base:
    (import.meta.env.VITE_TEMPLATE_ASSET_BASE as string | undefined) ||
    DEFAULT_TEMPLATE_ASSET_BASE,
});
